import { ref, watch, computed } from '@vue/composition-api';
import store from '@/store';
import { useToast } from 'vue-toastification/composition';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import { useUtils as useI18nUtils } from '@core/libs/i18n'

export default function useCategoryList() {
    const tableColumns = [
        { key: '', label: '', sortable: false },
        { key: 'title', label: 'Title', sortable: false },
        { key: 'slug', label: 'Slug', sortable: false },
        { key: 'is_active', label: 'Status', sortable: false },
        { key: 'action', label: '#', sortable: false }
    ];
    const isCatagoryFormSidebarActive = ref(false)
    const categoryData = ref(null);
    const toast = useToast()
    const searchQuery = ref('')
    const statusFilter = ref(null)
    const sortBy = ref('id')
    const isSortDirDesc = ref(true)
    const foodCategories = ref([])
    const totalFoodCategories = ref(0)
    const refCatagoryListTable = ref(null)
    const currentPage = ref(1)
    const perPage = ref(10)
    const perPageOptions = [10, 25, 50, 100]
    const dataMeta = computed(() => {
        if (!totalFoodCategories.value || totalFoodCategories.value === 0) {
            return { from: 0, to: 0, of: 0 };
        }
    
        const from = Math.max(1, perPage.value * (currentPage.value - 1) + 1);
        const to = Math.min(totalFoodCategories.value, perPage.value * currentPage.value);
    
        return {
            from,
            to,
            of: totalFoodCategories.value,
        };
    });
    // const dataMeta = computed(() => {
    //     const localItemsCount = refCatagoryListTable.value ? refCatagoryListTable.value.localItems.length : 0
    //     return {
    //         from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
    //         to: perPage.value * (currentPage.value - 1) + localItemsCount,
    //         of: totalFoodCategories.value,
    //     }
    // })

    const refetchCategoryData = () => {
        refCatagoryListTable.value.refresh()
        fetchCategoryData();
    }

    watch([currentPage, perPage, searchQuery, statusFilter], () => {
        refetchCategoryData()
    })

    const fetchCategoryData = (ctx, callback) => {
        const offset = perPage.value*(currentPage.value-1);
        const getLocalSite = JSON.parse(localStorage.getItem('site'))
        store
            .dispatch('app-food/getFoodCategories', {
                limit: perPage.value,
                offset:offset,
                keywords: searchQuery.value,
                sites_id: getLocalSite.id
            })
            .then(response => {
                foodCategories.value = response.data.data
                totalFoodCategories.value = response.data.total
            })
            .catch(() => {
                toast({
                    component: ToastificationContent,
                    props: {
                        title: "Error fetching Category' list",
                        icon: 'AlertTriangleIcon',
                        variant: 'danger',
                    },
                })
            })
    }

    const resolveCatagoryStatusVariant = status => {
        if (status ) return 'success'
        if (!status ) return 'secondary'
        return 'primary'
    }

    const resolveCatagoryStatusnameVariant = status => {
        if (status) return 'Active'
        if (!status) return 'Inactive'
        return 'primary'
    }

    const updateCategory = (data) => {
        categoryData.value = data
        isCatagoryFormSidebarActive.value = true
    }

    const deleteData = (id) => {
        store.dispatch('app-food/deleteCategory',id).then(response=>{
            toast({
                component: ToastificationContent,
                props: {
                title: "Delete Success",
                icon: 'AlertTriangleIcon',
                variant: 'success',
                },
            })
            fetchCategoryData();
        }).catch((error)=>{
            toast({
                component: ToastificationContent,
                props: {
                    title: "Error Delete Food Category",
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                },
            })
        })
      }

    return {
        tableColumns,
        categoryData,
        refetchCategoryData,
        searchQuery,
        fetchCategoryData,
        sortBy,
        isSortDirDesc,
        foodCategories,
        totalFoodCategories,
        dataMeta,
        refCatagoryListTable,
        currentPage,
        statusFilter,
        perPage,
        perPageOptions,
        resolveCatagoryStatusVariant,
        resolveCatagoryStatusnameVariant,
        updateCategory,
        isCatagoryFormSidebarActive,
        deleteData
    }
}